import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";

export interface CifraCotizador {
  label: string;
  /** Valor ya formateado (`$1,200,000`). */
  value: string;
}

interface Props {
  items: CifraCotizador[];
}

/**
 * Replica `.mc-sum` del cotizador de Mercader: las cifras clave de la estimación en una cuadrícula
 * de celdas separadas por una línea de 1px (el `gap` deja ver el borde del contenedor).
 */
export const ResumenCifrasCotizador = ({ items }: Props) => {
  const theme = useTheme();
  // El diseño baja a dos columnas por debajo de 900px.
  const isNarrow = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: isNarrow ? "repeat(2, minmax(0, 1fr))" : `repeat(${items.length}, minmax(0, 1fr))`,
        gap: "1px",
        bgcolor: "divider",
        border: "1px solid",
        borderColor: "divider",
        borderRadius: "10px",
        overflow: "hidden",
      }}
    >
      {items.map((item) => (
        <Box
          key={item.label}
          sx={{ display: "flex", flexDirection: "column", gap: "3px", bgcolor: "background.paper", p: "12px 14px" }}
        >
          <Typography variant="body3" color="tokens.textTertiary">
            {item.label}
          </Typography>
          <Typography variant="h5" sx={{ fontWeight: 600, color: "primary.dark", fontVariantNumeric: "tabular-nums" }}>
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};
